export function redirectToPortalV2({
	path,
	settingId,
	tenantId,
}: {
	path: string;
	settingId: number;
	tenantId?: number;
}): void {
	const url = new URL(`/v2/${path}`, window.location.origin);
	url.searchParams.set("settingId", String(settingId));
	if (tenantId !== undefined) {
		url.searchParams.set("tenantId", String(tenantId));
	}
	window.location.href = url.toString();
}
